import {Toast} from "primereact/toast";
import React from "react";
import {baseUrl} from "./webInfo";
import {deleteToken} from "@firebase/messaging";
import {Idata} from "../interfaces/interfaces";
import moment from "moment";

export default function callToast(
    toast: React.RefObject<Toast | null>,
    type: boolean | string,
    msg: string,
    life: number = 3000
) {
    if (toast?.current) {
        toast?.current?.show({
            severity: type === "warn" ? "warn" : type ? "success" : "error",
            summary: type === "warn" ? "Warning" : type ? "Successful" : "Error",
            detail: msg,
            life: life,
        });
    }
}

export const approvalStatus = [
    {
        id: 0, name: "Pending",
    },
    {
        id: 1, name: "Approved",
    },
    {
        id: 2, name: "Rejected"
    }
]

let timeout: any;
export const debounceFunction = (fn: Function, delay: number = 600) => {
    return (...arg: any) => {
        if (timeout) {
            clearTimeout(timeout)
        }
        timeout = setTimeout(() => {
            fn(...arg)
        }, delay)
    }
}

//Hide popup
export const hidePopup = (ref: { current: number }) => {
    ref.current = 0
}

// Custom delete function
export const handleDelete = async (params: any) => {
    const {
        id, endPoint, name, data = [], setData, token,
        toast, setUpdate
    } = params
    const filteredData = data.filter((data: any) => data?.id !== id);
    try {
        const res = await fetch(`${baseUrl.url}${endPoint}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify([{id: id}]),
        });

        if (res.ok) {
            if (data?.length > 0 && setData) {
                setData(filteredData);
            }

            if (setUpdate) {
                setUpdate((previous: boolean) => !previous)
            }
            callToast(toast, true, `${name} deleted successfully`);
        } else {
            const responseData = await res.json();
            callToast(toast, false, responseData?.errors[0]);
        }
    } catch (error: any) {
        callToast(toast, false, error?.message);
    }
};



export const handleChangeData = (name: string, value: any, allData: {
    [key: string]: string | Idata | any
}, setAllData: any) => {
    return setAllData({
        ...allData,
        [name]: value
    })
}

export const getFileExtension = (filename: string) => {
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop() : '';
}

export const handleDataUpdate = (id: number, value: any, allData: any, setAllData: any, name: string,) => {
    const updatedData = allData?.map((data: any) => {
        if (data?.id === id) {
            return {
                ...data,
                [name]: value
            }
        }
        return data
    })
    setAllData(updatedData)
}

export const handleRemoveRow = (id: number, allData: any, setAllData: any) => {
    const updatedData = allData?.filter((data: any) => data?.id !== id)
    setAllData(updatedData)
}

export const tablePerPageOptions = [10, 20, 30, 50, 100]


// Get Date Difference Function
export const getDiffInDays = (dateRange: Date[]) => {
    // Convert both dates to milliseconds
    const start = new Date(dateRange[0]).getTime();
    const end = new Date(dateRange[1]).getTime();
    // Calculate the difference in milliseconds
    const diffInMs = end - start;
    // Convert milliseconds to days (1 day = 86400000 milliseconds)
    return diffInMs / (1000 * 60 * 60 * 24);
}

// Notification Unsubscription
export const handleNotificationUnSubscription = async (notificationToken: string, messaging: any, accessToken: string) => {
    try {
        const response = await fetch(`${baseUrl.url}/api/notification_unsubscription`, {
            method: 'Delete',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({token: notificationToken})
        });
        if (response.ok) {
            localStorage.removeItem("notificationToken")
            if (notificationToken) {
                await deleteToken(messaging);
                console.log('Firebase Messaging token deleted successfully');
            } else {
                console.log('No Firebase Messaging token to delete');
            }
            localStorage.removeItem("notificationToken")
        }

    } catch (error) {
        console.error('Error getting token:', error);
    }

}

// Export Data
export const handleExportData = async (endPoint: string, type: string, token: string, toast: any, name = "",
                                       setExportLoading: Function, successFunction?: Function) => {
    try {
        setExportLoading(true)
        const res = await fetch(
            `${baseUrl.url}${endPoint}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const data = await res.blob();
        if (res.status === 204) {
            return callToast(toast, false, "No Data Found")
        }

        if (res.ok) {
            callToast(toast, true, `${name} ${type} download successfully`);
            if (successFunction) {
                successFunction()
            }
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `${name}.${type}`
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        } else {

        }
    } catch (error: any) {
        callToast(toast, false, error?.message)
    } finally {
        setExportLoading(false)
    }
};
// Download File
export const downloadFileInDevice = async(url:string) => {
    // let url = `https://apibanglatel.selopian.us/assets/images/user/user-38e38cb5-0992-49e7-aa0c-cbaf3b3e3e91.jpg`
    // const url = "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Googleplex_HQ_%28cropped%29.jpg/800px-Googleplex_HQ_%28cropped%29.jpg";
    try{
        const res = await  fetch(url)
        if(res.ok){
            const blob = await res.blob()
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob)
            link.download = `statement-${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }else{
            window.open(url, "_self")
        }

    }
    catch(error){
        console.log(error)
    }
};

export const getDisplayFileName = (filePath: string) => {
    if (!filePath) return 'Upload Document';
    const parts = filePath.split('/');
    const folderName = parts[parts.length - 2];
    const extension = parts[parts.length - 1]?.split('.').pop(); // e.g., 'png'
    // const shortName = folderName.split('__')[0]
    return `${folderName}.${extension}`;
};


export const getFileExtensionType = (filename: string): string => {
    return filename.split('.').pop()?.toLowerCase() || '';
};


// File Checker
export const isImageFile = (filename: string): boolean => {
    const imageExts: string[] = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const ext: string = getFileExtensionType(filename);
    return imageExts.includes(ext);
};

// Post JSON Format
export const postJson = (data: any) => {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }
};

// Post File Format
export const postFile = (File: any) => {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: File,
    }
};

// Catch Error
export const catchError = (error: any) => {
    console.log(error)
}

// Date Format Function
export const formattedDateTime = (date: string | Date, isTime: boolean = false) => {
    return moment(date).format(`${isTime ? `h:mm A,` : ""} Do MMM YYYY`)
}

export const mergeWithSelected = (dataList: any[], selected: any) => {
    if (!selected) return dataList;
    const exists = dataList.some((item) => item.id === selected.id);
    return exists ? dataList : [selected, ...dataList];
};


